export class Option {
    constructor(public label: string, public value: any) {
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/option.ts